<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key" i18n="@@common.name">Name:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty
              [data]="data.name"
              [length]="18"
            ></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.status">Status:</span>
          <span class="value">
            <gtd-ui-field-invoice-status [data]="data.status"></gtd-ui-field-invoice-status>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.comment">Comment:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.comment"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li *ngIf="!data.affiliate_cluster">
        <p>
          <span class="key" i18n="@@common.affiliate">Affiliate:</span>
          <span class="value">
            <gtd-ui-field-dynamic type="affiliate" [data]="data.affiliate"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li *ngIf="data.affiliate_cluster">
        <p>
          <span class="key" i18n="@@common.consolidation">Consolidation:</span>
          <span class="value">
            <gtd-ui-field-dynamic type="affiliate_cluster" [data]="data.affiliate_cluster"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.earning">Earning:</span>
          <span class="value">
            <gtd-ui-field-default-link
              [rbacProperty]="RbacPermissionsConstant.PAGES_SPECIAL_EARNING"
              [link]="['/app/finance-tools/earnings', data.earning?.id]"
              [displayData]="data.earning?.name"
              [relationData]="data.earning?.id"
            ></gtd-ui-field-default-link>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.additional">Additional</li>
      <li>
        <p>
          <span class="key" i18n="@@payment.method">Payment Method:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.payment_method"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@payment.currency">Payment Currency:</span>
          <span class="value">
            <gtd-ui-field-dynamic type="currency" [data]="data.payment_currency"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@payment.account">Payment Account:</span>
          <span class="value">
            <gtd-ui-field-default-protected [data]="data.payment_account"></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      @if (data.payment_method === 'Wire Transfer') {
      <li>
        <p>
          <span class="key" i18n="@@payment.details">Payment Details:</span>
          <span class="value">
            <gtd-ui-field-default-protected
              *ngIf="!unsecuredService.isUnsecuredValue"
              [data]="data.payment_details"
            ></gtd-ui-field-default-protected>
            <gtd-ui-field-default-string-whitespace-or-empty
              *ngIf="unsecuredService.isUnsecuredValue"
              [data]="data.payment_details"
            ></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      }
      <li>
        <p>
          <span class="key" i18n="@@common.description">Description:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.description"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span class="key" i18n="@@common.created_at">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.updated_at">Updated At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
